import { formatNumberWithCommas } from "../functions/utils";
export default class FeeCalculator {
    constructor(element) {
        this.passedElement = element;
        this.searchQuery = "";
        this.init();
    }

    init = () => {
        if (!this.initialised) {
            this.initialised = true;
            this.getElements();
            this.addEventListeners();
            this.calculateValues();
        }
    }

    getElements = () => {
        this.calculator = this.passedElement;
        this.calculatorForm = this.calculator.querySelector("#fee-calculator");
        this.accountValueSlider = this.calculatorForm.querySelector('#accountValue');
        this.AccountValueLabel = this.calculatorForm.querySelector('.accountValueLabel');
        this.platformFeeSlider = this.calculatorForm.querySelector('#platformFee');
        this.platformFeeLabel = this.calculatorForm.querySelector('.platformFeeLabel');
        this.calculatedYearDOM = this.calculatorForm.querySelector('#calculatedYear tspan');
        this.calculatedFeeDOM = this.calculatorForm.querySelector('#calculatedFee tspan');
    }

    calculateValues = () => {
        const basisPoints = 40;
        const platformFee = (basisPoints - this.platformFeeSlider.value)*0.01;
        const roundedFee = (Math.round((platformFee + Number.EPSILON) * 100) / 100).toFixed(2);
        const calculatedFeeAmount = ((platformFee/100) * this.accountValueSlider.value).toFixed(2);
        this.AccountValueLabel.innerHTML = `&pound;${formatNumberWithCommas(this.accountValueSlider.value)}`;
        this.platformFeeLabel.innerHTML = `${roundedFee}&percnt;`;
        this.calculatedYearDOM.innerHTML = `Year ${this.platformFeeSlider.value}`;
        this.calculatedFeeDOM.innerHTML = `&pound;${calculatedFeeAmount}`;
    }

    addEventListeners = () => {
        this.calculatorForm.addEventListener('change', () => this.calculateValues()); // fallback for browsers that do not support onInput events
        this.accountValueSlider.addEventListener('input', () => this.calculateValues());
        this.platformFeeSlider.addEventListener('input', () => this.calculateValues());
    }

    removeEventListeners = () => {
    }

    dismantle = () => {
    }

}